import { css, styled } from "../../../../../../styles";

export const TooltipCss = css({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",

  p: {
    fontSize: "14px",
    fontWeight: 500,
    fontFamily: "$openSans",
    margin: "2px 0",
  },
});

export const ChartWrapper = styled("div", {
  width: "100%",
  height: "100%",
  position: "relative",
  paddingRight: "12px",
});
